/*
__   __      _
\ \ / /__ __| |_ ___ _ _
 \ V / -_) _|  _/ _ \ '_|
  \_/\___\__|\__\___/_|
                         */

export class Vec2 {

    public x: number;
    public y: number;

    constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
    }

    public add(vec2: Vec2) {
        this.x += vec2.x;
        this.y += vec2.y;
        return this;
    }

    public sub(vec2: Vec2) {
        this.x -= vec2.x;
        this.y -= vec2.y;
        return this;
    }

    public multiplyScalar(val: number) {
        this.x *= val;
        this.y *= val;
        return this;
    }

    public divideScalar(val: number) {
        this.x /= val;
        this.y /= val;
        return this;
    }

    public length() {
        return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
    }

    public normalize() {
        this.divideScalar(this.length());
        return this;
    }

    public distance(vec2: Vec2) {
        return this.clone().sub(vec2).length();
    }

    public clone() {
        return new Vec2(this.x, this.y);
    }

    public dot(vec2: Vec2) {
        return this.x*vec2.x + this.y*vec2.y;
    }

    public angle(vec2: Vec2) {
        return Math.acos(this.dot(vec2)/(this.length()*vec2.length()));
    }

    public rotate(radians: number) {
        const vec2 = this.clone();
        const ca = Math.cos(radians);
        const sa = Math.sin(radians);
        this.x = ca*vec2.x - sa*vec2.y;
        this.y = sa*vec2.x + ca*vec2.y;
        return this;
    }

    public toJson() {
        return {
            x: this.x,
            y: this.y,
        };
    }

    public toString() {
      return `(${Math.round(this.x*100)/100},${Math.round(this.y*100)/100})`;
    }
}
